import*as R from"ramda";export const getHotjarUserTrackingAttributes=userDetails=>R.pick(["email","firstName","lastName","referralsSucceeded"],userDetails);